import clsx from "clsx";
import { HeaderCell } from "../HeaderCell/HeaderCell";
import { AccountAppearanceState } from "@/features/Labeling/Labeling.types";

export const AccountNameColDef = {
    headerName: "Account Name",
    colId: "accountName",
    pinned: "left" as const,
    width: 260,
    suppressSizeToFit: true,
    headerComponentParams: {
        innerHeaderComponent: HeaderCell,
    },
    suppressHeaderMenuButton: true,
    sortable: false,
    valueGetter: (params) => {
        return params.data.account?.accountName;
    },
};

export const AccountNameCellRenderer = ({
    accountName,
    appearanceState,
    canChangeAccount,
}: {
    appearanceState: AccountAppearanceState;
    canChangeAccount: boolean;
    accountName?: string | null;
}) => {
    if (!accountName)
        return (
            <div
                className={clsx(
                    "size-full",
                    canChangeAccount ? "cursor-default" : "cursor-pointer",
                )}
            />
        );

    return (
        <div
            className={clsx(
                "flex  size-full items-center justify-between",
                appearanceState === AccountAppearanceState.DEFAULT
                    ? "opacity-100"
                    : "opacity-50",
                canChangeAccount ? "cursor-default" : "cursor-pointer",
            )}
        >
            {accountName}
        </div>
    );
};
